import moment from 'moment'

let n = new Date();
const today = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0))
const yesterday = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 1, 0, 0))
let thisMonthStart = new Date(Date.UTC(n.getFullYear(), n.getMonth(), 1));
let thisMonthEnd = new Date(Date.UTC(n.getFullYear(), n.getMonth() + 1, 0));

let start = new Date("2018-01-01");
let startDate = new Date(Date.UTC(start.getFullYear(), start.getMonth(), start.getDate(), 0, 0))
let todayDate = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0))

export default {
  filters: {
    formatDateRange: function (value) {
      if (value) {
          return moment(new Date(value)).format('DD.MM.YYYY')
      }
    }
  },
  data() {
    return {
      dateRangeLocalFormat: {
        firstDay: 1,
        format: 'dd-mm-yyyy',
        direction: 'ltr',
        separator: ' - ',
        applyLabel: 'Применить',
        cancelLabel: 'Отмена',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        daysOfWeek: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
      },
      dateRanges: {
        'Сегодня': [today, today],
        'Вчера': [yesterday, yesterday],
        'Текущий месяц': [thisMonthStart, thisMonthEnd],
        'Предыдущий месяц': [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
        'Всё время': [startDate, todayDate],
      },
      range: {
        startDate: null,
        endDate: null
      },
      dateRange: 0,
    }
  },
  methods: {
    convertISODate(date) {
      return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
    }
  }
}



// WEBPACK FOOTER //
// ./resources/js/views/front/mixins/vue2DateRangePickerMixin.js